'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
var React = _interopDefault(require('react'));
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var colors = functions.config.colors.list;
var getFont = functions.config.fonts.getFont;
var handleListItemDisplay = function handleListItemDisplay(type) {
  switch (type) {
    case 'ordered':
      return 'flex';
    case 'unordered':
      return 'list-item';
    case 'iconList':
      return 'flex';
  }
};
var handleListPadding = function handleListPadding(type) {
  switch (type) {
    case 'ordered':
      return '0';
    case 'unordered':
      return '0 0 0 1.6rem';
    case 'iconList':
      return '0';
  }
};
var ListWrapper = styled.ul.withConfig({
  displayName: "Liststyled__ListWrapper",
  componentId: "sc-16yk5yv-0"
})(["margin:", ";list-style-position:outside;font-family:", ";list-style-type:none;padding:", ";counter-reset:listcounter;&,> li,> li > p{font-size:", ";line-height:1.5;};"], function (props) {
  return props.margin ? props.margin : '0';
}, function (props) {
  return getFont(props.theme, 'regular');
}, function (_ref) {
  var type = _ref.type;
  return handleListPadding(type);
}, function (_ref2) {
  var size = _ref2.size;
  switch (size) {
    case 'sm':
      return '1.2rem';
    case 'md':
      return '1.4rem';
    case 'lg':
      return '1.6rem';
    case 'xl':
      return '1.8rem';
  }
});
var ListItemWrapper = styled.li.withConfig({
  displayName: "Liststyled__ListItemWrapper",
  componentId: "sc-16yk5yv-1"
})(["position:relative;counter-increment:listcounter;display:", ";flex-direction:row;& li:first-of-type{margin-top:10px;}&::before{font-size:1em;position:", ";left:", ";top:0;color:", ";display:block;width:", ";height:10px;}", " ", " ", " & + &{margin-top:1.2rem;}"], function (_ref3) {
  var type = _ref3.type;
  return handleListItemDisplay(type);
}, function (props) {
  return props.type === 'ordered' ? 'relative' : 'absolute';
}, function (props) {
  return props.type === 'ordered' ? '0' : '-1.3rem';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.dark ? colors.White : colors.BlueDark;
}, function (props) {
  return props.type === 'ordered' ? 'auto' : '10px';
}, function (props) {
  return props.type === 'ordered' && "\n    &::before {\n      flex: 0 0 auto;\n      content: counters(listcounter, \".\") \". \";\n      margin-right: .8rem;\n      text-align: right;\n    }\n  ";
}, function (props) {
  return props.type === 'unordered' && "\n    &::before {\n      content: '\u2022';\n    }\n  ";
}, function (props) {
  return props.type === 'iconList' && "\n    > :first-child {\n      margin-right: .4rem;\n      flex: 0 0 auto;\n    }\n    > :first-child + * {\n      margin-top: 0;\n      flex: 1 1 auto;\n    }\n  ";
});
var IcnCheck = function IcnCheck(props) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M17.944 6.639l-8.328 8.173-3.06-3.003a.385.385 0 0 0-.537 0l-.896.879a.368.368 0 0 0 0 .527l4.224 4.146a.385.385 0 0 0 .538 0l9.492-9.316a.368.368 0 0 0 0-.527l-.896-.88a.385.385 0 0 0-.537 0z"
  }));
};
var IcnCheckBold = function IcnCheckBold(props) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M10.095 17.761L5.22 12.534a.846.846 0 0 1 0-1.137l1.06-1.137a.715.715 0 0 1 1.061 0l3.284 3.52 7.034-7.541a.715.715 0 0 1 1.06 0l1.061 1.137a.846.846 0 0 1 0 1.137l-8.625 9.248a.715.715 0 0 1-1.06 0z"
  }));
};
var IcnCheckLight = function IcnCheckLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18.458 6.615l-9.173 9.191-3.243-3.249a.393.393 0 0 0-.556 0l-.37.371a.394.394 0 0 0 0 .557l3.89 3.9a.393.393 0 0 0 .557 0l9.822-9.841a.394.394 0 0 0 0-.557l-.37-.372a.393.393 0 0 0-.557 0z"
  }));
};
var IcnCross = function IcnCross(props) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.9 12.25l5.42-5.42a.5.5 0 0 0 0-.71l-.94-.94a.5.5 0 0 0-.71 0l-5.42 5.42-5.42-5.42a.5.5 0 0 0-.71 0l-.94.94a.5.5 0 0 0 0 .71l5.42 5.42-5.42 5.42a.5.5 0 0 0 0 .71l.94.94a.5.5 0 0 0 .71 0l5.42-5.42 5.42 5.42a.5.5 0 0 0 .71 0l.94-.94a.5.5 0 0 0 0-.71l-5.42-5.42z"
  }));
};
var IcnCrossLight = function IcnCrossLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.362 12.25l5.984-5.984a.524.524 0 0 0 0-.742l-.37-.37a.524.524 0 0 0-.742 0l-5.984 5.984-5.984-5.98a.524.524 0 0 0-.742 0l-.37.37a.524.524 0 0 0 0 .742l5.984 5.98-5.98 5.984a.524.524 0 0 0 0 .742l.37.37a.524.524 0 0 0 .742 0l5.98-5.984 5.984 5.984a.524.524 0 0 0 .742 0l.37-.37a.524.524 0 0 0 0-.742l-5.984-5.984z"
  }));
};
var colors$1 = functions.config.colors.list;
var IconToRender = function IconToRender(_ref) {
  var props = _extends({}, _ref);
  switch (props.icon) {
    case 'icn_checkLight':
      return /*#__PURE__*/React.createElement(IcnCheckLight, {
        color: props.color
      });
    case 'icn_checkBold':
      return /*#__PURE__*/React.createElement(IcnCheckBold, {
        color: props.color
      });
    case 'icn_cross':
      return /*#__PURE__*/React.createElement(IcnCross, {
        color: props.color
      });
    case 'icn_crossLight':
      return /*#__PURE__*/React.createElement(IcnCrossLight, {
        color: props.color
      });
    default:
    case 'icn_check':
      return /*#__PURE__*/React.createElement(IcnCheck, {
        color: props.color
      });
  }
};
var List = function List(_ref2) {
  var type = _ref2.type,
    iconColor = _ref2.iconColor,
    children = _ref2.children,
    icon = _ref2.icon,
    className = _ref2.className,
    margin = _ref2.margin,
    size = _ref2.size;
  var childrenWithProps;
  if (type === 'iconList') {
    childrenWithProps = React.Children.toArray(children).map(function (child, id) {
      return /*#__PURE__*/React.createElement(ListItemWrapper, {
        key: "listItem_".concat(id),
        type: type
      }, /*#__PURE__*/React.createElement(IconToRender, {
        icon: icon,
        color: icon && colors$1[iconColor]
      }), React.cloneElement(child));
    });
  } else {
    childrenWithProps = React.Children.toArray(children).map(function (child, id) {
      return /*#__PURE__*/React.createElement(ListItemWrapper, {
        key: "listItem_".concat(id),
        type: type
      }, React.cloneElement(child));
    });
  }
  return /*#__PURE__*/React.createElement(ListWrapper, {
    type: type,
    size: size,
    className: className,
    margin: margin
  }, childrenWithProps);
};
List.defaultProps = {
  type: 'unordered',
  icon: 'icn_check',
  iconColor: 'BlueSky',
  size: 'md'
};
var ListItem = styled.li.withConfig({
  displayName: "ListItem",
  componentId: "mdnklu-0"
})(["& + &{margin-top:2rem;}"]);
var ListItemText = styled.p.withConfig({
  displayName: "ListItemText",
  componentId: "sc-12cslos-0"
})(["margin:0;padding:0;line-height:1.4;& + &{margin-top:2rem;}"]);
var getFont$1 = functions.config.fonts.getFont;
var colors$2 = functions.config.colors.list;
var StepContent = styled.div.withConfig({
  displayName: "Step__StepContent",
  componentId: "sc-1qfi6ar-0"
})(["position:relative;top:.2rem;"]);
var StepItem = styled.li.withConfig({
  displayName: "Step__StepItem",
  componentId: "sc-1qfi6ar-1"
})(["align-items:flex-start;display:flex;flex-direction:row;flex-wrap:nowrap;font-family:", ";justify-content:flex-start;margin:0 0 2rem;min-width:0.1rem;padding-left:3.5rem;position:relative;width:100%;z-index:1;counter-increment:step-counter;&::before{border-left:dashed .1rem ", ";border-left:none;content:'';background:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMXB4IiBoZWlnaHQ9IjZweCIgdmlld0JveD0iMCAwIDEgNiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTcuMSAoODMwODgpIC0gaHR0cHM6Ly9za2V0Y2guY29tIC0tPgogICAgPHRpdGxlPkFydGJvYXJkPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IkFydGJvYXJkIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtZGFzaGFycmF5PSIzLDMsMywzIj4KICAgICAgICA8cGF0aCBkPSJNMC41LC02IEwwLjUsNi4yMjQ2MDkzNyIgaWQ9IlBhdGgtMy1Db3B5IiBzdHJva2U9IiMwMEIzREIiPjwvcGF0aD4KICAgIDwvZz4KPC9zdmc+Cg==\") repeat-y center center;display:", ";height:calc(100% - .1rem);left:1.1rem;position:absolute;top:2.3rem;width:.1rem;font-size:1.2rem;}&:last-of-type{margin-bottom:0;&::before{height:calc(100% - 2.3rem);}}"], getFont$1({}, 'regular'), colors$2.BlueSky, function (props) {
  return props.hideCounter ? 'none' : 'block';
});
var StepCounter = styled.span.withConfig({
  displayName: "Step__StepCounter",
  componentId: "sc-1qfi6ar-2"
})(["position:absolute;left:0;top:0;&::before,&::after{align-items:center;box-sizing:border-box;display:", ";height:2.3rem;justify-content:center;left:0;position:absolute;top:0;width:2.3rem;color:", ";font-family:", ";}&::before{background:transparent;border-radius:50%;border:.2rem solid ", ";content:'';}&::after{top:-.1rem;content:counter(step-counter);}"], function (props) {
  return props.hideCounter ? 'none' : 'flex';
}, colors$2.BlueSky, getFont$1({}, 'bold'), colors$2.BlueSky);
var Step = function Step(_ref) {
  var children = _ref.children,
    hideCounter = _ref.hideCounter;
  return /*#__PURE__*/React.createElement(StepItem, {
    hideCounter: hideCounter
  }, /*#__PURE__*/React.createElement(StepCounter, {
    hideCounter: hideCounter
  }), /*#__PURE__*/React.createElement(StepContent, null, children));
};
Step.defaultProps = {
  hideCounter: false
};
var getFont$2 = functions.config.fonts.getFont;
var StepList = styled.ul.withConfig({
  displayName: "Stepper__StepList",
  componentId: "u32oo3-0"
})(["font-family:", ";list-style-type:none;margin:0 0 3.2rem;padding:0;counter-reset:step-counter;li:nth-last-child(2){", "}margin:", ";"], function (props) {
  return getFont$2(props.theme, 'regular');
}, function (props) {
  return props.hideLastCounter && "\n        margin-bottom: 1rem;\n        &::before {\n          height: calc(100% - 2.4rem);\n        }\n      ";
}, function (props) {
  return props.margin;
});
var Stepper = function Stepper(_ref) {
  var children = _ref.children,
    hideCounter = _ref.hideLastCounter,
    margin = _ref.margin;
  var childrens = React.Children.toArray(children);
  var childrenWithProps = childrens.map(function (child, index) {
    return childrens.length - 1 === index ? React.cloneElement(child, {
      hideCounter: hideCounter
    }) : React.cloneElement(child);
  });
  return /*#__PURE__*/React.createElement(StepList, {
    hideLastCounter: hideCounter,
    margin: margin
  }, childrenWithProps);
};
Stepper.defaultProps = {
  hideLastCounter: false,
  children: null
};
exports.default = List;
exports.List = List;
exports.ListItem = ListItem;
exports.ListItemText = ListItemText;
exports.Step = Step;
exports.Stepper = Stepper;